const moduleName = "LanguageSelector";

export default function LanguageSelector() {
  const $elements = document.querySelectorAll<HTMLElement>(
    "[module-language-selector]:not([data-module-enabled-language-selector])"
  );
  $elements.forEach(($element: HTMLElement) => {
    handleEl($element);
  });
}

const handleEl = ($element: HTMLElement) => {
  $element.dataset[`moduleEnabled${moduleName}`] = "";
  const $form = $element.querySelector("form");
  const $input = $element.querySelector(
    'input[name="language_code"]'
  ) as HTMLInputElement;
  const $languages = $element.querySelectorAll<HTMLLinkElement>(
    ".language-selector__link"
  );
  if (!$form || !$input) {
    throw new Error("Missing elements");
  }

  const $button = $element.querySelector("button");
  if ($button) {
    $button.addEventListener("click", (e) => {
      e.stopPropagation();
      $element.classList.toggle("is-open");
    });
  }

  document.addEventListener("click", (e) => {
    if (!$element.contains(e.target as Node)) {
      $element.classList.remove("is-open");
    }
  });

  $languages.forEach(($language) => {
    $language.addEventListener("click", () => {
      const language = $language.dataset.value;
      if (language) {
        $input.value = language;
        $form.submit();
      }
    });
  });
};